const Swal = require('sweetalert2');
 
/**
* Activate submit button, if any of form field are filled with value ,
* For Laravel jsvalidator issue
*/
$('form').on('keyup keydown focus focusin focusout keypress select check blur change', function () {
    $(':input[type="submit"]').prop('disabled', false);
});
 
// Prevent dropdown clicks from closing
$(document).on('click', '.external-dropdown-menu', function (e) {
    e.stopPropagation();
});
 
// IT Department Popup Dialog
$(document).ready(function () {
    const $popup = $('#it-dept-popup');
    const $overlay = $('#popup-overlay');
    const $closeBtn = $('#popup-close');
    const $scrollContent = $('.it-dept-scroll-content');
 
    /* ======================
       CONTENT DUPLICATION (ONCE)
    ====================== */
 
    // Wrap original content
    if (!$scrollContent.find('.scroll-inner').length) {
        $scrollContent.wrapInner('<div class="scroll-inner"></div>');
    }
 
    const $inner = $scrollContent.find('.scroll-inner');
 
    // Duplicate for seamless loop
    $scrollContent.append($inner.clone());
 
    const scrollElement = $scrollContent.get(0);
    let autoScrollRafId = null;
    let lastFrameTime = null;
    let pendingPixels = 0;
    let isAutoScrolling = false;
    let isHovering = false;
 
    /* ======================
       OPEN / CLOSE HANDLERS
    ====================== */
 
    $('#it-dept-link').on('click', function (e) {
        e.preventDefault();
        openPopup();
    });
 
    $closeBtn.on('click', closePopup);
    $overlay.on('click', closePopup);
 
    $(document).on('keydown', function (e) {
        if (e.keyCode === 27 && $popup.is(':visible')) {
            closePopup();
        }
    });
 
    function openPopup() {
        $popup.fadeIn(300, function () {
            if (!$popup.is(':visible')) return;
            resetScrollPosition();
            startAutoScroll();
        });
        $('body').css('overflow', 'hidden');
    }
 
    function closePopup() {
        $popup.fadeOut(300);
        $('body').css('overflow', '');
 
        stopAutoScroll();
        resetScrollPosition();
    }
 
    /* ======================
       AUTO SCROLL LOGIC
    ====================== */
 
    function startAutoScroll() {
        if (isAutoScrolling || isHovering) return;
 
        isAutoScrolling = true;
        lastFrameTime = null;
        pendingPixels = 0;
        autoScrollRafId = window.requestAnimationFrame(stepAutoScroll);
    }
 
    function stopAutoScroll() {
        isAutoScrolling = false;
        lastFrameTime = null;
        pendingPixels = 0;

        if (autoScrollRafId) {
            window.cancelAnimationFrame(autoScrollRafId);
            autoScrollRafId = null;
        }
    }
 
    function resetScrollPosition() {
        if (!scrollElement) return;
        scrollElement.scrollTop = 1;
    }

    function stepAutoScroll(timestamp) {
        if (!isAutoScrolling || isHovering || !scrollElement || !$popup.is(':visible')) {
            isAutoScrolling = false;
            autoScrollRafId = null;
            return;
        }

        if (!lastFrameTime) {
            lastFrameTime = timestamp;
        }

        const dt = (timestamp - lastFrameTime) / 1000;
        lastFrameTime = timestamp;

        const scrollTop = scrollElement.scrollTop;
        const innerHeight = $inner.outerHeight();
        const pxPerSecond = scrollTop < 120 ? 12 : 20;

        // Safari may ignore fractional scrollTop values, so accumulate
        // fractional movement and only apply full pixels.
        pendingPixels += pxPerSecond * dt;
        const wholePixels = Math.trunc(pendingPixels);

        if (wholePixels !== 0) {
            pendingPixels -= wholePixels;
            scrollElement.scrollTop = scrollTop + wholePixels;

            if (scrollElement.scrollTop >= innerHeight) {
                scrollElement.scrollTop = 1; // NOT 0 → prevents jump
            }
        }

        autoScrollRafId = window.requestAnimationFrame(stepAutoScroll);
    }
 
    /* ======================
       HOVER PAUSE / RESUME
    ====================== */
 
    $scrollContent.on('mouseenter', function () {
        isHovering = true;
        stopAutoScroll();
    });
 
    $scrollContent.on('mouseleave', function () {
        isHovering = false;
 
        if ($popup.is(':visible')) {
            startAutoScroll();
        }
    });
 
    /* ======================
       MANUAL SCROLL SUPPORT
    ====================== */

    $scrollContent.on('wheel touchstart', function () {
        stopAutoScroll();
    });

    // Keep the seamless loop working during manual scroll
    $scrollContent.on('scroll', function () {
        if (isAutoScrolling) return;
        const scrollTop = scrollElement.scrollTop;
        const innerH = $inner.outerHeight();
        if (scrollTop >= innerH) {
            scrollElement.scrollTop = scrollTop - innerH;
        } else if (scrollTop <= 0 && innerH > 0) {
            scrollElement.scrollTop = innerH - 1;
        }
    });
});
 
 
 
// login action
$('a#logout').on('click', function () {
    $('form#logout').submit();
})
 
/**
* Allows you to add data-method="METHOD to links to automatically inject a form
* with the method on click
*
* Example: <a href="{{route('customers.destroy', $customer->id)}}"
* data-method="delete" name="delete_item">Delete</a>
*
* Injects a form with that's fired on click of the link with a DELETE request.
* Good because you don't have to dirty your HTML with delete forms everywhere.
*/
function addDeleteForms() {
    $('[data-method]')
        .append(function () {
            if (!$(this).find('form').length > 0) {
                return (
                    "\n<form action='" +
                    $(this).attr('href') +
                    "' method='POST' name='delete_item' style='display:none'>\n" +
                    "<input type='hidden' name='_method' value='" +
                    $(this).attr('data-method') +
                    "'>\n" +
                    "<input type='hidden' name='_token' value='" +
                    $('meta[name="csrf-token"]').attr('content') +
                    "'>\n" +
                    '</form>\n'
                );
            } else {
                return '';
            }
        })
        .attr('href', '#')
        .attr('style', 'cursor:pointer;')
        .attr('onclick', '$(this).find("form").submit();');
}
 
/**
* Place any jQuery/helper plugins in here.
*/
$(function () {
    /**
     * Add the data-method="delete" forms to all delete links
     */
    addDeleteForms();
 
    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        $(this).find('input[type="submit"]').attr('disabled', true);
        $(this).find('button[type="submit"]').attr('disabled', true);
        return true;
    });
 
    /**
     * Generic confirm form delete using Sweet Alert
     */
    $('body')
        .on('submit', 'form[name=delete_item]', function (e) {
            e.preventDefault();
 
            const form = this;
            const link = $('a[data-method="delete"]');
            const cancel = link.attr('data-trans-button-cancel') ? link.attr('data-trans-button-cancel') : 'Cancel';
            const confirm = link.attr('data-trans-button-confirm')
                ? link.attr('data-trans-button-confirm')
                : 'Yes, delete';
            const title = link.attr('data-trans-title')
                ? link.attr('data-trans-title')
                : 'Are you sure you want to delete this item?';
 
            Swal.fire({
                title: title,
                showCancelButton: true,
                confirmButtonText: confirm,
                cancelButtonText: cancel,
                icon: 'warning',
            }).then((result) => {
                result.value && form.submit();
            });
        })
        .on('click', 'a[name=confirm_item]', function (e) {
            /**
             * Generic 'are you sure' confirm box
             */
            e.preventDefault();
 
            const link = $(this);
            const title = link.attr('data-trans-title')
                ? link.attr('data-trans-title')
                : 'Are you sure you want to do this?';
            const cancel = link.attr('data-trans-button-cancel') ? link.attr('data-trans-button-cancel') : 'Cancel';
            const confirm = link.attr('data-trans-button-confirm')
                ? link.attr('data-trans-button-confirm')
                : 'Continue';

            const isUpgradeCorporate =
                link.attr('data-amplitude-upgrade-corporate') === '1';
            const upgradeCustomerId = link.attr('data-amplitude-entity-id');
            const upgradeSource =
                link.attr('data-amplitude-source') || 'customer_dropdown';

            if (isUpgradeCorporate && typeof window.trackCustomerUpgradeToCorporateClick === 'function') {
                window.trackCustomerUpgradeToCorporateClick(upgradeSource);
            }
 
            Swal.fire({
                title: title,
                showCancelButton: true,
                confirmButtonText: confirm,
                cancelButtonText: cancel,
                icon: 'info',
            }).then((result) => {
                if (result.value) {
                    window.location.assign(link.attr('href'));
                } else if (
                    isUpgradeCorporate &&
                    result.dismiss === Swal.DismissReason.cancel &&
                    typeof window.trackCustomerCancelUpgradeToCorporate === 'function'
                ) {
                    window.trackCustomerCancelUpgradeToCorporate(upgradeCustomerId);
                }
            });
        });
 
    $('[data-toggle="tooltip"]').tooltip();
});
 
//data-table lock action
$('.lock-action-btn').on('click', function () {
    // Getting the closest table-container for the button clicked
    var tableContainer = $(this).closest('.card').find('.table-container');
 
    $(this).toggleClass("lock-active");
    tableContainer.find("thead tr th:last-child").toggleClass("lock-column");
    tableContainer.find("tfoot tr th:last-child").toggleClass("lock-column");
    tableContainer.find("tbody tr td:last-child").toggleClass("lock-column");
});
 
/**
 * Clean up orphaned dropdown elements from body.
 * Called before DataTable re-renders to prevent duplicate IDs.
 */
function cleanupOrphanedDropdowns() {
    // Get all dropdown IDs currently in the table
    var dropdownIdsInTable = new Set();
    $('.user-more-dropdown').each(function() {
        var userId = $(this).data('userId') || $(this).closest('tr').find('td:first').text().trim() || $(this).attr('id').replace('btnGroupDrop', '');
        dropdownIdsInTable.add('dropdown-' + userId);
    });
    
    // Remove dropdowns in body that are not in the current table
    $('body > .external-dropdown-menu').each(function() {
        var dropdownId = $(this).attr('id');
        if (dropdownId && !dropdownIdsInTable.has(dropdownId)) {
            $(this).remove();
        }
    });
}

/**
 * Attach DataTable event listeners to clean up dropdowns on redraw.
 */
$(document).on('init.dt', function(e, settings) {
    var $table = $(e.delegateTarget);
    
    // Clean up before and after table redraw
    $table.on('preDraw.dt', function() {
        cleanupOrphanedDropdowns();
    });
});

// Handle external dropdown functionality
$(document).on('click', '.user-more-dropdown', function (e) {
    e.preventDefault();
    e.stopPropagation();
    
    var $button = $(this);
    var userId = $button.data('userId') || $button.closest('tr').find('td:first').text().trim() || $button.attr('id').replace('btnGroupDrop', '');
    var $dropdown = $('#dropdown-' + userId);
    
    // Move dropdown to body to escape table stacking context
    if ($dropdown.length && $dropdown.parent()[0].tagName !== 'BODY') {
        $('body').append($dropdown);
    }
    
    // Toggle: if already visible, hide and return
    if ($dropdown.is(':visible')) {
        $dropdown.hide();
        return;
    }

    // Hide all other dropdowns
    $('.external-dropdown-menu').not($dropdown).hide();
    
    // Calculate position
    var buttonRect = $button[0].getBoundingClientRect();
    var dropdownWidth = 165; // Match the min-width
    var viewportWidth = window.innerWidth;
    
    // Calculate left position to align right edge with button
    var leftPosition = buttonRect.right - dropdownWidth;
    if (leftPosition + dropdownWidth > viewportWidth) {
        leftPosition = viewportWidth - dropdownWidth - 10; // 10px padding from edge
    }
    if (leftPosition < 10) {
        leftPosition = 10; // 10px padding from left edge
    }
    
    // Position and show dropdown with maximum z-index
    $dropdown.css({
        'top': (buttonRect.bottom + 2) + 'px', // 2px gap from button
        'left': leftPosition + 'px',
        'display': 'block',
        'z-index': '999999999',
        'position': 'fixed',
        'min-width': '165px',
    });
});
 
// Hide dropdown when clicking outside
$(document).on('click', function (e) {
    if (!$(e.target).closest('.user-more-dropdown, .external-dropdown-menu').length) {
        $('.external-dropdown-menu').hide();
    }
});
 
 
$(function(){
    var current = location.pathname;
    $('#primary-sidebar li a').each(function(){
        var $this = $(this);
 
        if($this.attr('href').indexOf(current) !== -1){
    var elem = $this;
        if (elem) {
            var main = $("#primary-sidebar"),
                t = main.offset().top;
            main.scrollTop(elem.offset().top - t );
        }
        }
    })
})